import useProtoMethod from "./useProtoMethod";
import {
  AnswerAgentQuestionRequest,
  AnswerAgentQuestionResponse,
  AgentMessageResponse,
  AgentMessageRequest,
  GetAgentsThreadRequest,
  GetAgentsThreadResponse,
  CreateAgentPromptResponse,
  CreateAgentPromptRequest,
  UpdateAgentPromptRequest,
  UpdateAgentPromptResponse,
  ListAgentPromptsRequest,
  ListAgentPromptsResponse,
  FetchPromptInvocationRequest,
  FetchPromptInvocationResponse,
  InterruptAgentThreadRequest,
  InterruptAgentThreadResponse,
  RetryAgentThreadRequest,
  RetryAgentThreadResponse,
  StartAgentResponse,
  StartAgentRequest,
  ToggleAgentPromptRequest,
  ToggleAgentPromptResponse,
  ListAgentToolsRequest,
  ListAgentToolsResponse,
  ListFailedAgentThreadsRequest,
  ListFailedAgentThreadsResponse,
} from "protogen/agents_service_pb";
import { getApiDomain } from "../constants";

const useStartAgent = (callback?: (r: StartAgentResponse) => void) => {
  return useProtoMethod<StartAgentRequest, StartAgentResponse>(
    "StartAgent",
    StartAgentResponse,
    { baseUrl: getApiDomain(), callback },
  );
};

const useAnswerAgentQuestion = (
  callback?: (r: AnswerAgentQuestionResponse) => void,
) => {
  return useProtoMethod<
    AnswerAgentQuestionRequest,
    AnswerAgentQuestionResponse
  >("AnswerAgentQuestion", AnswerAgentQuestionResponse, {
    baseUrl: getApiDomain(),
    callback,
  });
};

const useAgentMessage = (callback?: (r: AgentMessageResponse) => void) => {
  return useProtoMethod<AgentMessageRequest, AgentMessageResponse>(
    "AgentMessage",
    AgentMessageResponse,
    { baseUrl: getApiDomain(), callback },
  );
};

const useGetAgentsThread = (
  callback?: (r: GetAgentsThreadResponse) => void,
) => {
  return useProtoMethod<GetAgentsThreadRequest, GetAgentsThreadResponse>(
    "GetAgentsThread",
    GetAgentsThreadResponse,
    { baseUrl: getApiDomain(), callback },
  );
};

const useCreateAgentPrompt = (
  callback?: (r: CreateAgentPromptResponse) => void,
) => {
  return useProtoMethod<CreateAgentPromptRequest, CreateAgentPromptResponse>(
    "CreateAgentPrompt",
    CreateAgentPromptResponse,
    { baseUrl: getApiDomain(), callback },
  );
};

const useUpdateAgentPrompt = (
  callback?: (r: UpdateAgentPromptResponse) => void,
) => {
  return useProtoMethod<UpdateAgentPromptRequest, UpdateAgentPromptResponse>(
    "UpdateAgentPrompt",
    UpdateAgentPromptResponse,
    { baseUrl: getApiDomain(), callback },
  );
};

const useListAgentPrompts = (
  callback?: (r: ListAgentPromptsResponse) => void,
) => {
  return useProtoMethod<ListAgentPromptsRequest, ListAgentPromptsResponse>(
    "ListAgentPrompts",
    ListAgentPromptsResponse,
    { baseUrl: getApiDomain(), callback },
  );
};

const useFetchPromptInvocation = (
  callback?: (r: FetchPromptInvocationResponse) => void,
) => {
  return useProtoMethod<
    FetchPromptInvocationRequest,
    FetchPromptInvocationResponse
  >("FetchPromptInvocation", FetchPromptInvocationResponse, {
    baseUrl: getApiDomain(),
    callback,
  });
};

const useInterruptAgentThread = (
  callback?: (r: InterruptAgentThreadResponse) => void,
) => {
  return useProtoMethod<
    InterruptAgentThreadRequest,
    InterruptAgentThreadResponse
  >("InterruptAgentThread", InterruptAgentThreadResponse, {
    baseUrl: getApiDomain(),
    callback,
  });
};

const useRetryAgentThread = (
  callback?: (r: RetryAgentThreadResponse) => void,
) => {
  return useProtoMethod<RetryAgentThreadRequest, RetryAgentThreadResponse>(
    "RetryAgentThread",
    RetryAgentThreadResponse,
    { baseUrl: getApiDomain(), callback },
  );
};

const useToggleAgentPrompt = (
  callback?: (r: ToggleAgentPromptResponse) => void,
) => {
  return useProtoMethod<ToggleAgentPromptRequest, ToggleAgentPromptResponse>(
    "ToggleAgentPrompt",
    ToggleAgentPromptResponse,
    { baseUrl: getApiDomain(), callback },
  );
};

const useListAgentTools = (callback?: (r: ListAgentToolsResponse) => void) => {
  return useProtoMethod<ListAgentToolsRequest, ListAgentToolsResponse>(
    "ListAgentTools",
    ListAgentToolsResponse,
    { baseUrl: getApiDomain(), callback },
  );
};

const useListFailedAgentThreads = () => {
  return useProtoMethod<
    ListFailedAgentThreadsRequest,
    ListFailedAgentThreadsResponse
  >("ListFailedAgentThreads", ListFailedAgentThreadsResponse, {
    baseUrl: getApiDomain(),
  });
};

export {
  useStartAgent,
  useAnswerAgentQuestion,
  useAgentMessage,
  useGetAgentsThread,
  useCreateAgentPrompt,
  useUpdateAgentPrompt,
  useListAgentPrompts,
  useFetchPromptInvocation,
  useInterruptAgentThread,
  useRetryAgentThread,
  useToggleAgentPrompt,
  useListAgentTools,
  useListFailedAgentThreads,
};
